export default {"src":"/_next/static/media/stereo_system.2af5c809.svg","height":100,"width":100};